// FR-J3/J5, restored by July-8 FR-L2: the deliberate confirmation pop-ups that MUST fire before
// the two AE-gated advances, on EVERY control that performs them. Both advance surfaces
// (PreprintsPortal cards and the Details ChangeStatus card) read from this single map so the
// strings/gating can't silently diverge again — the popup regressed once exactly that way.
import type { SelectedStatus } from "@rrid/shared-types";

export const ADVANCE_CONFIRMS: Partial<Record<SelectedStatus, string>> = {
  // shown when advancing To Pitch(Team) → To Pitch(Editorial)
  "To Pitch(Editorial)": "You've finalized and verified the reviewer profile going to editorial?",
  // shown when advancing To Pitch(Editorial) → Selected (FR-J5)
  Selected: "Did you make the reviewer-profile changes discussed in editorial?",
};

/** Gate an advance: returns true when the transition may proceed (confirmed or no popup needed). */
export function confirmAdvance(target: SelectedStatus): boolean {
  const message = ADVANCE_CONFIRMS[target];
  return !message || window.confirm(message);
}
